<template>
  <v-container fluid class="pa-0">

    
    <picture>
      <source media="(max-width: 480px)" srcset="../assets/bg_sp.jpg" />
      <img :src="BgImg" class="responsive-img" />
    </picture>


    <About /> 
    
    <!-- DLC使用方法 -->
    <LinkButton href="http://d-mebius.com/elminages/serial">
    <strong>特典コードの使用方法</strong>
    </LinkButton>
    <!-- 配信ガイドライン -->
    <LinkButton href="http://d-mebius.com/elminages/stream">
    <strong>実況・動画配信のガイドライン</strong>
    </LinkButton>
    <!-- バグ報告フォーム -->
    <LinkButton href="http://d-mebius.com/elminages/support">
    <strong>不具合報告フォーム</strong>
    </LinkButton>
    <!-- 説明書 -->
    <LinkButton href="http://d-mebius.com/elminages/guide">
    <strong>ゲームガイド</strong>
    </LinkButton>
    
    <!-- <Story /> -->
    <!-- ゲーム説明 -->
    <!-- それぞれのタイトルへのリンク -->
    <!-- スクショ -->
    <SS />

    <!-- 製品情報 -->
    <ProductPage />

    <!-- ニュース -->
    <AppNews />


  </v-container>
</template>

<script>
  import AppNews from "./AppNews.vue";

  import ProductPage from "./SoftProduct.vue";
  import LinkButton from "./LinkButton.vue";
  //  import Caution from "./CautionStream.vue";
  import About from "./AboutGame.vue";
  import image1 from "../assets/bg.jpg";
  import SS from "./ScreenShot.vue";
  // import Story from "./GameStory.vue";

  export default {
    name: "TopPage",
    components: {
      AppNews,
      ProductPage,
      LinkButton,
      // Caution,
      About,
      SS,
      //Story,
    },
    data: () => ({
      BgImg: image1,
    }),
  };
</script>

<style scoped>
  .bold {
    color: #ff1744;
    font-weight: bold;
  }
  .responsive-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
